
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Navimumbaiairportcabservice() {



const cardData = {
  keyword: 'Navi Mumbai Airport Cab Service',
  heading: 'Skyline Cabs: Navi Mumbai Airport Cab Service',
  headingDescription: 'Skyline Cabs offers professional, punctual, and affordable Navi Mumbai Airport Cab Service designed for seamless airport transfers. Whether you need a pickup from the terminal, an early morning airport taxi, late-night airport cab service, or a scheduled drop to Navi Mumbai Airport, we guarantee on-time arrivals and smooth travel. Our fleet includes AC sedan cab like Swift Dzire and Hyundai Aura, Ertiga cab, Kia Carens, Innova Crysta airport cab service, premium SUV cab, and Tempo Traveller airport service for group transfers. We track flight schedules in real-time to adjust pickup timings in case of delays and provide meet-and-greet support at the airport. With transparent pricing, zero hidden charges, 24x7 availability, corporate billing options, and secure online Navi Mumbai Airport cab booking system, Skyline Cabs is your trusted airport transfer partner. Book your Navi Mumbai Airport Cab Service today and experience safe, comfortable, and stress-free airport travel.',

  top: 'Top Places to Visit in Navi Mumbai with Skyline Cabs',

  "topPlaces": [
    {
      "title": "Central Park, Kharghar",
      "description": "Central Park is one of Navi Mumbai’s most iconic recreational spaces, spread across acres of beautifully landscaped greenery. It features walking tracks, musical fountains, amphitheater spaces, and event grounds that host exhibitions and cultural programs. Families, fitness enthusiasts, and tourists frequently visit for relaxation and recreation. The park offers scenic views of surrounding hills and modern infrastructure. Skyline Cabs provides comfortable airport transfer service Navi Mumbai that allows you to explore Central Park conveniently before or after your flight."
    },
    {
      "title": "Pandavkada Waterfalls",
      "description": "Pandavkada Waterfalls near Kharghar is a breathtaking natural attraction, especially during monsoon season. Surrounded by lush hills and fresh air, the waterfall attracts adventure seekers and nature lovers. It is ideal for short treks, photography, and peaceful relaxation. The scenic environment makes it one of Navi Mumbai’s favorite weekend destinations."
    },
    {
      "title": "Belapur Fort",
      "description": "Belapur Fort is a historic landmark offering panoramic views of Navi Mumbai’s skyline and creek areas. Built during the Portuguese era, the fort reflects architectural strength and historical importance. It is surrounded by greenery and peaceful surroundings, making it a perfect place for history lovers and explorers."
    },
    {
      "title": "Palm Beach Road",
      "description": "Palm Beach Road is known for its picturesque sea-facing drive connecting Vashi and Belapur. It is considered one of India’s most scenic roads. Evening drives along this stretch provide breathtaking sunset views. Skyline Cabs offers sedan and SUV airport cab service Navi Mumbai for smooth drives across this iconic road."
    },
    {
      "title": "DY Patil Stadium",
      "description": "DY Patil Stadium is a major sports and entertainment venue hosting IPL matches, concerts, and large-scale events. With modern infrastructure and international standards, it is one of Navi Mumbai’s landmarks. Visitors can enjoy nearby shopping and dining options."
    },
    {
      "title": "Nerul Balaji Temple",
      "description": "Inspired by the Tirupati Balaji Temple, Nerul Balaji Temple is a peaceful spiritual destination built on a hill. It offers stunning city views and serene surroundings. Devotees visit regularly for prayers and religious ceremonies."
    },
    {
      "title": "Rock Garden, Nerul",
      "description": "Rock Garden is a beautifully maintained sea-facing garden featuring artistic sculptures and walking paths. It is perfect for families, couples, and relaxation seekers looking for calm surroundings."
    },
    {
      "title": "Karnala Bird Sanctuary",
      "description": "Karnala Bird Sanctuary is home to over 200 bird species and offers scenic trekking trails leading to Karnala Fort. It’s an eco-tourism hotspot near Navi Mumbai."
    },
    {
      "title": "Seawoods Grand Central Mall",
      "description": "Seawoods Grand Central Mall is a premium shopping and entertainment destination with global brands, multiplex cinemas, and dining options."
    },
    {
      "title": "Utsav Chowk, Kharghar",
      "description": "Utsav Chowk is known for its European-style architecture and vibrant atmosphere. It’s a popular evening hangout spot with cafes and restaurants."
    }
  ],

  "services": [
    {
      "name": "24x7 Navi Mumbai Airport Cab Service",
      "description": "Skyline Cabs offers 24x7 Navi Mumbai Airport Cab Service including early morning airport taxi and late night airport cab service. Our drivers are available round-the-clock for on-time airport transfers."
    },
    {
      "name": "Navi Mumbai Airport Pickup & Drop Service",
      "description": "Book reliable airport cab service Navi Mumbai for both pickup and drop transfers. We provide flight tracking, luggage assistance, and punctual service."
    },
    {
      "name": "Innova & Innova Crysta Airport Cab Service",
      "description": "Choose Innova airport cab service Navi Mumbai or Innova Crysta Navi Mumbai Airport cab service for premium, spacious, and comfortable airport transfers."
    },
    {
      "name": "Sedan & Ertiga Airport Cab Service",
      "description": "Affordable sedan airport cab service Navi Mumbai including Swift Dzire, Hyundai Aura, and Ertiga cab Navi Mumbai Airport cab service."
    },
    {
      "name": "SUV & Luxury Airport Cab Service",
      "description": "Book SUV cab Navi Mumbai Airport cab service or luxury airport cab service Navi Mumbai for executive and corporate travel."
    },
    {
      "name": "Tempo Traveller Airport Service Navi Mumbai",
      "description": "Planning group airport travel? Book Tempo Traveller airport service Navi Mumbai for spacious and comfortable transfers."
    }
  ],

  "tableData": [
    ["Navi Mumbai Airport Cab Service", "Navi Mumbai Airport Taxi Service"],
    ["24x7 Navi Mumbai Airport Cab Service", "Late Night Airport Cab Service Navi Mumbai"],
    ["Early Morning Airport Taxi Navi Mumbai", "Reliable Airport Cab Service Navi Mumbai"],
    ["Cheapest Cab Service Navi Mumbai Airport", "Best Cab Service Navi Mumbai Airport"],
    ["Innova Crysta Navi Mumbai Airport Cab Service", "Ertiga Cab Navi Mumbai Airport Cab Service"],
    ["Sedan Airport Cab Service Navi Mumbai", "SUV Airport Cab Service Navi Mumbai"],
    ["Tempo Traveller Airport Service Navi Mumbai", "Corporate Cab Service Navi Mumbai Airport"]
  ],

  whychoose: [
    {
      "WhyChooseheading": "On-Time & Reliable Airport Cab Service",
      "WhyChoosedescription": "Skyline Cabs is known for reliable Navi Mumbai Airport Cab Service with strict punctuality standards. We track flights in real-time and adjust pickup timings accordingly. Our drivers arrive early, assist with luggage, and ensure smooth transfers without last-minute stress. Whether early morning airport taxi or midnight pickup, we guarantee dependable service."
    },
    {
      "WhyChooseheading": "Wide Fleet for Every Travel Need",
      "WhyChoosedescription": "From budget sedan cab to Innova cab, Ertiga cab, Kia Carens, Hyundai Aura, premium SUV, and Tempo Traveller airport service Navi Mumbai, we provide a vehicle for every requirement. Corporate travelers, families, and group passengers all find suitable options."
    },
    {
      "WhyChooseheading": "Transparent & Affordable Pricing",
      "WhyChoosedescription": "Our cheapest cab service Navi Mumbai Airport offers clear pricing structure with no hidden charges. Toll, fuel, and driver allowances are included in the quoted fare."
    },
    {
      "WhyChooseheading": "24/7 Online Booking & Secure Payments",
      "WhyChoosedescription": "Book cab service for Navi Mumbai Airport anytime through our secure online Navi Mumbai Airport cab booking platform. We support multiple payment options and instant confirmations."
    }
  ]
}



const faqData = [
    {
        id: 1,
        question: 'How can I book a Navi Mumbai Airport Cab Service with Skyline Cabs?',
        answer:
            'You can easily book your Navi Mumbai Airport Cab Service through our website or mobile app. Enter your pickup or drop location, select the airport ride option, choose your preferred vehicle, and confirm your booking instantly.',
    },
    {
        id: 2,
        question: 'Is Skyline Cabs available 24/7 for Navi Mumbai Airport transfers?',
        answer:
            'Yes, our Navi Mumbai Airport Cab Service operates 24/7, including late-night and early-morning airport pickups and drops to ensure you never miss your flight.',
    },
    {
        id: 3,
        question: 'Can I schedule my Navi Mumbai Airport Cab Service in advance?',
        answer:
            'Absolutely! You can pre-book your airport cab days or even weeks in advance to secure timely pickup and avoid last-minute rush.',
    },
    {
        id: 4,
        question: 'What vehicles are available under Navi Mumbai Airport Cab Service?',
        answer:
            'We provide a wide fleet including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars — suitable for individuals, families, and corporate travelers.',
    },
    {
        id: 5,
        question: 'Are the fares for Navi Mumbai Airport Cab Service transparent?',
        answer:
            'Yes, Skyline Cabs follows transparent pricing. The fare shown during booking includes tolls, taxes, and driver charges with no hidden fees.',
    },
    {
        id: 6,
        question: 'Do you offer flight tracking for airport pickups?',
        answer:
            'Yes, our Navi Mumbai Airport Cab Service includes flight tracking so that our drivers adjust pickup timing in case of flight delays.',
    },
    {
        id: 7,
        question: 'Is online payment available for airport cab bookings?',
        answer:
            'Yes, we offer secure online payment options such as UPI, credit/debit cards, and net banking. Instant booking confirmation is sent after payment.',
    },
    {
        id: 8,
        question: 'Can I book a round-trip Navi Mumbai Airport Cab Service?',
        answer:
            'Yes, while booking you can select the round-trip option and schedule your return ride conveniently in one go.',
    },
    {
        id: 9,
        question: 'Is this service suitable for corporate airport transfers?',
        answer:
            'Definitely. Skyline Cabs provides professional drivers, clean vehicles, punctual service, and proper billing support for corporate airport transfers.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Navi Mumbai Airport Cab Service?',
        answer:
            'Skyline Cabs ensures on-time airport transfers, experienced chauffeurs, sanitized cars, affordable pricing, and 24x7 customer support — making us a reliable choice for Navi Mumbai Airport Cab Service.',
    },
];

const someReviews = [
    {
        name: "Mr. Amit Patil",
        rating: 5,
        review: "Skyline’s Navi Mumbai Airport Cab Service was excellent. The driver was punctual, the car was clean, and the entire journey was smooth. Highly professional service!"
    },
    {
        name: "Ms. Ritu Sharma",
        rating: 4,
        review: "Very convenient airport cab booking experience. Transparent pricing and timely pickup made my airport travel stress-free. Definitely recommend Skyline Cabs."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    
      const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Airport Cab Service",
  "image": "https://skylinecabs.com/assets/images/navi-mumbai-airport-cab-service.jpg",
  "description": "Book Navi Mumbai Airport Cab Service with Skyline Cabs for 24x7 reliable and affordable airport transfers. Safe airport pickup and drop with sedan, SUV, Innova and luxury cars driven by professional chauffeurs.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/navi-mumbai-airport-cab-service"
  }
};



    return (
        <div>


<Helmet>
  <title>Navi Mumbai Airport Cab Service | 24x7 Airport Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Navi Mumbai Airport Cab Service with Skyline Cabs for 24x7 airport pickup and drop. Reliable, affordable and luxury airport taxi service available for corporate and personal travel." 
  />
  <meta 
    name="keywords" 
    content="navi mumbai airport cab service, navi mumbai airport taxi service, airport cab service navi mumbai, navi mumbai airport taxi, navi mumbai airport cab, book cab service for navi mumbai airport, online navi mumbai airport cab service, best cab service navi mumbai airport, reliable airport cab service navi mumbai, cheapest cab service navi mumbai airport, 24x7 navi mumbai airport cab service, late night airport cab service navi mumbai, early morning airport taxi navi mumbai, corporate cab service navi mumbai airport, luxury airport cab service navi mumbai, airport transfer service navi mumbai, innova airport cab service navi mumbai, Skyline Cabs Navi Mumbai Airport Service" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/115.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Navimumbaiairportcabservice;